// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../../common/JQueryView';

export default class ShowView extends JQueryView {
  isAttachedPitch: boolean;

  constructor(isAttachedPitch: boolean) {
    super('.entrepreneurs');

    $(window).on('load scroll', () => {
      fix_header();
      add_class_in_scrolling('vision');
      add_class_in_scrolling('profile');
      add_class_in_scrolling('issue');
      add_class_in_scrolling('service');
      if (isAttachedPitch) {
        add_class_in_scrolling('pitch');
      }
      add_class_in_scrolling('message');
      add_class_in_scrolling('company');
    });

    function add_class_in_scrolling(target) {
      const winScroll = $(window).scrollTop();
      const headerHeight = 180;
      const scrollPos = winScroll + headerHeight;

      if ($(`#${target}-field`).offset().top < scrollPos) {
        $('.nav-link')
          .filter('.active')
          .removeClass('active');
        $(`.${target}-link`).addClass('active');
      }
    }

    function fix_header() {
      const winScroll = $(window).scrollTop();
      const headerHeight = 70;
      const scrollPos = winScroll + headerHeight;
      if (
        !$('.entrepreneur-show-body').hasClass('tab-fixed-show-body') &&
        $('.header-field').offset().top < scrollPos
      ) {
        $('.header-field').addClass('fix-tab');
        $('.entrepreneur-show-body').addClass('tab-fixed-show-body');
      } else if (
        $('.entrepreneur-show-body').hasClass('tab-fixed-show-body') &&
        $('.header-field').offset().top < 290
      ) {
        $('.header-field').removeClass('fix-tab');
        $('.entrepreneur-show-body').removeClass('tab-fixed-show-body');
      }
    }

    $('.issue-detail-fields').each((index, item) => {
      $(item).attr('id', `issue-readmore-${index + 5}`);
      $(item)
        .find('.readmore-check')
        .attr('id', `check-${index + 5}`);
      $(item)
        .find('.contents')
        .attr('id', `issue-content-${index + 5}`);
      $(item)
        .find('.readmore-label')
        .attr('for', `check-${index + 5}`);
    });

    const row = 6;
    const lineHeight = 28;
    const fieldHeight = row * lineHeight;

    if (
      $('#vision-content').height() <= fieldHeight ||
      $('#vision-content').height() == null
    ) {
      $('#vision-readmore').removeClass('readmore');
      $('#check1').hide();
    }

    if ($('#introduction-content').height() <= fieldHeight) {
      $('#introduction-readmore').removeClass('readmore');
      $('#check2').hide();
    }

    if (
      $('#service-content').height() <= fieldHeight ||
      $('#service-content').height() == null
    ) {
      $('#service-readmore').removeClass('readmore');
      $('#check3').hide();
    }

    if ($('#message-content').height() <= fieldHeight) {
      $('#message-readmore').removeClass('readmore');
      $('#check4').hide();
    }

    $('.issue-detail-fields').each(index => {
      if ($(`#issue-content-${index + 5}`).height() <= fieldHeight) {
        $(`#issue-readmore-${index + 5}`).removeClass('readmore');
        $(`#check-${index + 5}`).hide();
      }
    });
  }

  moveToElement(toElement: string) {
    const headerHeight = 150;
    $('html, body').animate(
      {
        scrollTop: $(`#${toElement}`).offset().top - headerHeight,
      },
      1000,
    );
  }

  @on({ event: 'click', selector: '.vision-link' })
  clickVisionLink(e: any) {
    e.preventDefault();
    this.moveToElement('vision-field');
  }

  @on({ event: 'click', selector: '.profile-link' })
  clickProfileLink(e: any) {
    e.preventDefault();
    this.moveToElement('profile-field');
  }

  @on({ event: 'click', selector: '.issue-link' })
  clickIssueLink(e: any) {
    e.preventDefault();
    this.moveToElement('issue-field');
  }

  @on({ event: 'click', selector: '.service-link' })
  clickServiceLink(e: any) {
    e.preventDefault();
    this.moveToElement('service-field');
  }

  @on({ event: 'click', selector: '.pitch-link' })
  clickPitchLink(e: any) {
    e.preventDefault();
    this.moveToElement('pitch-field');
  }

  @on({ event: 'click', selector: '.message-link' })
  clickMessageLink(e: any) {
    e.preventDefault();
    this.moveToElement('message-field');
  }

  @on({ event: 'click', selector: '.company-link' })
  clickCompanyLink(e: any) {
    e.preventDefault();
    this.moveToElement('company-field');
  }
}
